<template>
    <Dialog ref="synchroMediaModal" :callback="synchroMediaSave" width="600" :title="title">
        <div slot="mdBox">
            <div class="warp clearfix">
                <div class="warp-item fl">
                    <div class="search-warp">
                        <input type="text" name="search" v-model="keyWord" placeholder="请输入关键字搜素" class="input-text" @keyup="searchUser();"> 
                        <span class="search-btn" href="javascript:void(0);">
                            <i class="icons search-icon1"></i>
                        </span>
                    </div>
                    <div class="box h322 mt4">
                        <ul class="one-level">
                            <li class="li clearfix" v-for="(item,index) in list" :key="index">
                                <div class="checkbox-warp clearfix">
                                    <label class="checkbox fl">
                                        <input type="checkbox" class="checkbox-i" @click="checkAll($event,index);" :checked="$utils.isIncludes(mediaIds,item.ids) == true && item.ids.length > 0 ? true : false"> 
                                        <span class="checkbox-ico"></span> 
                                    </label>
                                    <span @click="showTwoLevel(index)">
                                        <span>{{item.name}}</span>
                                        <i class="icons up-icon" :class="{closes:!item.show}"></i>
                                    </span>
                                </div>
                                <ul class="two-level" v-show="item.show">
                                    <li v-for="(items,index) in item.list" :key="index">
                                        <label class="checkbox clearfix">
                                            <div class="checkbox-inside fl">
                                                <input type="checkbox" v-model="mediaIds" class="checkbox-i" :value="items.id"> 
                                                <span class="checkbox-ico"></span> 
                                            </div>
                                            <div class="imgText hidden clearfix">
                                                <img :src="items.picurl" onerror="this.src='static/images/headImg.png'" class="img fl"/>
                                                <div class="hidden"><span class="name fl">{{items.nickname}}</span></div>
                                            </div>
                                        </label>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="warp-item fr">
                    <ul class="box select h354">
                        <li class="li clearfix" v-for="(item,index) in selectList" :key="index">
                            <div class="imgText hidden clearfix">
                                <img :src="item.picurl" onerror="this.src='static/images/headImg.png'" class="img fl"/>
                                <div class="hidden clearfix">
                                    <span class="name fl">{{item.nickname}}</span>
                                    <div class="fr">
                                        <!-- <i class="icons" :class="$parent.platformImg[item.type-1]"></i> -->
                                        <a class="icons close-icon" href="javascript:void(0);" @click="delUser(item.id);"></a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </Dialog>
</template>
<script>
import Dialog from './dialog.vue';
export default {
    components:{Dialog},
    name:'',
    props: {
        listPass:{//列表传输
            type:Boolean,
            default: false
        },
        dataArray: { 
            type: Array | Object
        },
        line:{//列表传输
            type:Boolean,
            default: false
        },
        title:{
            type:String,
            default:function(){
                return '添加审核人';
            }, 
        },
    },
    data() {
        return {
            materialType:1,//媒体类别 
            initialMediaList:[],//公众号初始列表
            initialList:[],
            list:[],
            keyWord:'',//关键词
            mediaIds:[],
            allIds:[],//初始数组的所有ID
            ids:[],//二维数组
            selectList:[] //公号已选列表 
        }
    },
    created () {
        
    },
    mounted () {
        
    },
    methods: {
        // 获取账户列表
        getUesrList () {
            let that = this;
            that.allIds = [];
            let list = that.dataArray;
            that.initialMediaList = list;
            for(let i of list){//获得所有的ID
                for(let j of i.list){
                    that.allIds.push(j.id); 
                }
            }
            that.againMakeArray();
        },
        
        // 重新生成数组
        againMakeArray () {
            let that = this;
            let ids = that.ids;//已选列表
            let allIds = that.allIds;
            let list = that.initialMediaList;//初始列表
            let arr = [];
            let news = [];
            if(ids.length > 0){//已有选择列表
                for(let i of ids){
                    arr = ([...arr,...i])//生成一个合并数组，便于去重获得新数组
                }
            }
            let data = allIds.filter(el => !~arr.indexOf(el))
            for(let j of list){
                let h = [];
                let id = [];
                for(let n of j.list){
                    for(let m of data){
                        if(n.id === m){
                            h.push(n);
                            id.push(n.id);
                        }
                    }
                }
                news.push({
                    'name':j.name,
                    'list':h,
                    'ids':id,
                    'show':true
                });
            }
            that.list = news;
            that.initialList = news;
            if(that.mediaIds.length > 0){//需要回显已选列表
                that.makeList();
            }
            that.$refs.synchroMediaModal.showMaskFun();
        },
        // 筛选
        searchUser () {
            let that = this;
            let keyWord = that.keyWord;
            let list = that.list;
            let lists = [];
            if(keyWord != ''){
                for(let i of list){
                    let name = i.name;
                    i.show = true;
                    let show = i.show;
                    let arr = [];
                    let ids = [];
                    for(let j of i.list){
                        let val = j.nickname;
                        if(val.indexOf(keyWord) != -1){
                            arr.push(j);
                            ids = ids.concat(j.id)
                        }
                    }
                    if(arr != ''){
                        lists.push({
                            'name':name,
                            'show':show,
                            'ids':ids,
                            'list':arr
                        })
                    }
                }
            }else{
                lists = that.initialList;
            }
            
            that.list = lists;
        },
        // 全选状态
        checkAll (e,index) {
            let that = this;
            let list = that.list;
            let ids = list[index].ids;
            let mediaIds = that.mediaIds;
            let checked = e.target.checked;
            if(checked == true){//全选
                mediaIds = mediaIds.concat(ids);
            }else{//全不选
                for(let j of ids){
                    mediaIds = mediaIds.filter(item => item !== j);
                }
            }
            that.mediaIds = mediaIds;
        },
        // 收起
        showTwoLevel (index) {
            let that = this;
            let list = that.list;
            if(list[index].show){
                list[index].show = false;
            }else{
                list[index].show = true;
            }
        },
        // 删除预选列表
        delUser (id) {
            let that = this;
            let selectList = that.selectList; 
            let mediaIds = that.mediaIds;
            let ids = [];
            for(let i of mediaIds){//重新拼装数组
                ids.push(i);
            }
            let index = ids.indexOf(id);
            ids.splice(index,1);
            that.mediaIds = ids;
            that.makeList();
        },
        // 生成已选列表
        makeList () {
            let that = this;
            let mediaIds = that.mediaIds;
            let list = '';
            list = that.list;
            let selectList = [];
            
            if(list.length > 0){
                for(let i of list){
                    for(let j of mediaIds){
                        for(let n of i.list){
                            if(n.id === j){
                                selectList.push(n); 
                            }   
                        }
                    }
                }
            }
            that.selectList = selectList;
        },
        // 同步到公众号后台
        synchroPublicNumber () {
            let that = this;
            if(that.line == true){
                that.ids = [];
            }else{
                that.mediaIds = [];
            }
            that.selectList = [];
            that.getUesrList();
            // that.$refs.synchroMediaModal.showMaskFun();
        },
        // 确认同步到公众号后台
        synchroMediaSave () {
            let that = this;
            if(that.mediaIds.length <= 0){
                that.$utils.alertText('请选择媒体账号');
                return;
            }
            if(that.line == true){
                that.ids = that.mediaIds;
            }else{
                that.ids.push(that.mediaIds);
            }
            that.$refs.synchroMediaModal.closeMask();
            if(that.listPass){
                that.$emit('peopleCallback',[that.ids,that.selectList]);
            }else{
                that.$emit('peopleCallback',that.ids);
            }
        }
    },
    watch:  {
        // materialType (val) {
        //     this.getTabList();
        //     this.setList(this.initialMediaList[val-1]);
        // },
        mediaIds (val) {
            this.makeList(); 
        }
    }
}
</script>
<style lang="" scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/peopleSelect.vue